module.exports = __webpack_public_path__ + "assets/img/is-urgent.4aa6623f.svg";